module.exports = __webpack_public_path__ + "static/img/5.54281b4d.png";